import HubspotForm from "@components/HubspotForm";
import Section from "@components/Section";
import { ComponentSectionsHubspotForm } from "@lib/generated/graphql";
import { FC } from "react";
import SectionImage from "../../../../components/SectionBlocks/SectionImage";
import TwoColumnLayout from "../../../../components/SectionBlocks/TwoColumnLayout";

export interface HubspotFormProps {
  data: ComponentSectionsHubspotForm;
  index: number;
}

const HubspotFormSection: FC<HubspotFormProps> = ({ data, index }) => {
  return (
    <Section section={data}>
      <TwoColumnLayout data={data.layout}>
        <TwoColumnLayout.FirstColumn className="m:py-3xl" data={data.layout}>
          <HubspotForm
            isDoubleOptIn={data.isDoubleOptIn}
            id={data.id}
            formId={data.hubspotFormId}
          />
        </TwoColumnLayout.FirstColumn>
        {data.image && (
          <TwoColumnLayout.SecondColumn className="flex" data={data.layout}>
            <SectionImage data={data.image} index={index} />
          </TwoColumnLayout.SecondColumn>
        )}
      </TwoColumnLayout>
    </Section>
  );
};

export default HubspotFormSection;
